import { useElitePlansLanding } from '../ElitePlansLandingContext'
import NewEliteLandingTrustStatement from '../../new-elite-landing/components/NewEliteLandingTrustStatement'

export function ElitePlansTrustStatement() {
  const { activeTab } = useElitePlansLanding()
  return (
    <NewEliteLandingTrustStatement
      variant={activeTab.themeId}
      wordmarkRiveSrc={
        activeTab.themeId === 'elite'
          ? '/images/elite-plans/elite/elite_footer_asset.riv'
          : '/images/elite-plans/elite/prime_footer_asset.riv'
      }
      hideBackground
    />
  )
}
